export default "__VITE_ASSET__myGIor1w__"